// extracted by mini-css-extract-plugin
module.exports = {"itemPanel":"antd-pro-pages-editor-koni-components-editor-item-panel-index-itemPanel"};